import React, { memo } from 'react';
import { useI18n } from '../../i18n';
import Loader from './Loader';

import S from './style/ModalSheetBottom';

interface ModalSheetBottomProps {
  isVisible: boolean;
  title: string;
  onClose: () => void;
  onConfirm?: () => void;
  closeLabel?: string;
  confirmLabel?: string;
  description?: string;
  additionalContent?: React.ReactNode;
  loading?: boolean;
  icon?: React.ReactNode;
  bottomSection?: React.ReactNode;
}
const ModalSheetBottom: React.FC<ModalSheetBottomProps> = function ModalSheetBottom({
  isVisible,
  title,
  onClose,
  onConfirm,
  confirmLabel,
  closeLabel,
  description,
  additionalContent,
  loading,
  icon,
  bottomSection,
}) {
  const i18n = useI18n();

  return (
    <S.SheetBottomModal
      closeButtonText={!loading && !bottomSection && (closeLabel || i18n('dlv_generics_cancel'))}
      isVisible={isVisible}
      onClose={!loading ? onClose : null}
      data-cy="sheet-bottom"
      data-testid="sheet-bottom"
    >
      <S.Container>
        {loading ? (
          <Loader />
        ) : (
          <>
            {icon && <S.ImageContainer>{icon}</S.ImageContainer>}
            <S.Headline data-testid="title">{title}</S.Headline>
            <S.Description data-testid="description">{description}</S.Description>
            {additionalContent}
            {onConfirm && (
              <S.ConfirmButton data-cy="accept-button" mb={10} onClick={onConfirm}>
                {confirmLabel || i18n('dlv_generics_accept')}
              </S.ConfirmButton>
            )}
            {bottomSection && (
              <>
                <S.CloseButtonInBottomSection
                  onClick={onClose}
                  data-testid="close-btn-bottom-section"
                >
                  {!loading && (closeLabel || i18n('dlv_generics_cancel'))}
                </S.CloseButtonInBottomSection>
                <S.BottomSection>{bottomSection}</S.BottomSection>
              </>
            )}
          </>
        )}
      </S.Container>
    </S.SheetBottomModal>
  );
};

export default memo(ModalSheetBottom);
